import router from './router'
import store from './store'
import NProgress from 'nprogress'
import {Message} from 'element-ui'
import '@/styles/nprogress.css'
import {getToken} from '@/utils/auth'
import getPageTitle from '@/utils/get-page-title'
import _ from "lodash";

NProgress.configure({showSpinner: false})

const whiteList = ['/login', '/about']

router.beforeEach(async (to, from, next) => {
  NProgress.start()

  document.title = getPageTitle(to.meta.title)

  const hasToken = getToken()
  if (hasToken) {
    if (to.path === '/login') {
      next({path: '/expert'})
      NProgress.done()
    } else {
      const hasUser = store.getters.user && store.getters.user.id;
      if (hasUser) {
        next()
      } else {
        try {
          await store.dispatch('sys/getUser')
          next({...to, replace: true})
        } catch (error) {
          // remove token and go to login page to re-login
          Message.error(error || 'Has Error')
          //next(`/login?redirect=${to.path}`)
          NProgress.done()
        }
      }
    }
  } else {
    if (to.path === "/") {
      next();
      return;
    }
    const find = _.find(whiteList, function (o) {
      return _.startsWith(to.path, o)
    });
    if (find) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})
router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/user/permission.js